module.exports = __webpack_public_path__ + "static/assets/ea253b4d59fb4421746a7206f13213fe.jpg";